import Typography from "@material-ui/core/Typography";
import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import dateFormat from "dateformat";
import {getMessage} from "../../util";
import Chip from "@material-ui/core/Chip";
import {Card, CardContent} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
        chip: {
            marginLeft: theme.spacing(2)
        },
        paragraph: {
            margin: theme.spacing(2)
        },
        title: {
            fontFamily: "Montserrat",
            fontSize: "2.0rem",
            textAlign: "center"
        },
        label: {
            fontFamily: "Montserrat",
            fontSize: "1.5rem"
        },
        number: {
            fontFamily: "Montserrat",
            fontSize: "2.5rem",
            fontWeight: "bold"
        }
    }
));


const QueueHeader = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.paragraph}>
            <Typography variant="h5" className={classes.title} >
                {props.title}
            </Typography>
            {props.myTurnStyle ? (
                <Card variant="outlined" style={{textAlign: "center", backgroundColor: "antiquewhite"}}>
                    <CardContent>
                        <Fragment>
                            <Typography variant="h4" className={classes.label}>
                                {props.label}
                            </Typography>
                            <Typography variant="h2" className={classes.number}>
                                {props.number}
                            </Typography>
                        </Fragment>
                    </CardContent>
                </Card>
            ): (
                <Card variant="outlined" style={{textAlign: "center", backgroundColor: "aquamarine"}}>
                    <CardContent>
                        <Fragment>
                            <Typography variant="h4" className={classes.label}>
                                {props.label}
                            </Typography>
                            <Typography variant="h2" className={classes.number}>
                                {props.number}
                            </Typography>
                        </Fragment>
                    </CardContent>
                </Card>
            )}

        </div>
       )
}

export default QueueHeader;